import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../api/baseURL';

const fetchFeatureFlags = async () => {
  const { data } = await axios.get(`${API_URL}/admin/feature-flags`);
  return data.features || {};
};

export function useFeatureFlags() {
  const queryClient = useQueryClient();

  const { data: features = {}, isLoading } = useQuery({
    queryKey: ['featureFlags'],
    queryFn: fetchFeatureFlags,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
  });

  const isFeatureEnabled = (key) => {
    if (isLoading) return true; // graceful degradation: show everything while loading
    if (!features[key]) return true; // unknown key = enabled by default
    return features[key].enabled !== false;
  };

  const invalidate = () => queryClient.invalidateQueries({ queryKey: ['featureFlags'] });

  return { features, isLoading, isFeatureEnabled, invalidate };
}
